import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/button'
import Container from '@/components/base/container'
import SVGIcon from '@/components/base/svg-icon'
import TextEffect from '@/components/base/text-effect'
import Typography from '@/components/base/typography'

import { WPLink } from '@/types'

export type BtnDownloadProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    button: WPLink
  }>

const BtnDownload = ({ button, ...props }: BtnDownloadProps) => {
  return button?.url ? (
    <section {...props}>
      <Container className="text-center">
        <Button
          className="min-h-[4.8rem]"
          isLiquid={true}
          isInverted={false}
          asChild
          variant="primary"
          endIcon={
            <SVGIcon
              symbol="pdf-icon"
              className="ml-auto size-[1.8rem] shrink-0 fill-current"
            />
          }
        >
          <Link
            href={button.url}
            target={button.target || '_self'}
            scroll={false}
          >
            <TextEffect>
              <Typography variant="regular">{button.title}</Typography>
            </TextEffect>
          </Link>
        </Button>
      </Container>
    </section>
  ) : null
}

export default BtnDownload
